"use client";

import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Container, Heading, useThemeSlot } from "@huub-web/ui";
import type { AppUser } from "@huub-web/backend";
import { Section } from "@huub-web/shared";

import { usePageReady } from "../../hooks/usePageReady";
import { AdvisorBookingContext } from "./AdvisorBookingContext";
import { DefaultAppointmentBooking } from "./DefaultAppointmentBooking";
import { headingStyle } from "./AdvisorScreen.css";

/**
 * Screen component for advisor interactions.
 * Uses the appointmentBooking ThemeSlot to render either the default
 * Calendly widget or a theme-specific alternative.
 */
export const AdvisorScreen: FC<{ user: AppUser; url: string }> = ({
  user,
  url,
}) => {
  const { t } = useTranslation();

  const BookingWidget = useThemeSlot({
    key: "appointmentBooking",
    defaultComponent: DefaultAppointmentBooking,
  });

  usePageReady();

  return (
    <Section>
      <Container>
        <Heading
          title={t("advisor.screen.title")}
          description={t("advisor.screen.description")}
          variant="main"
          className={headingStyle}
        />
      </Container>

      <Container size="s">
        <AdvisorBookingContext.Provider value={{ user, url }}>
          <BookingWidget />
        </AdvisorBookingContext.Provider>
      </Container>
    </Section>
  );
};
